import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA,
  MatLegacyDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBar } from '@angular/material/legacy-snack-bar';
import { BehaviorSubject } from 'rxjs';

// CONFIGS
import { MaterialCustomModule } from 'v2/material-custom.module';
import { SnackBarConfig } from 'v2/modules/shared/configs/snackbar.config';

// INTERFACES
import { IShipment } from 'v2/modules/shared/interfaces/order-shipment.interface';

// SERVICES
import { PipeModule } from 'v2/modules/shared/pipes/pipe.module';
import { ShipstationShipmentApiService } from 'v2/modules/shared/services/api/shipstation-shipment-api.service';

// MODULES
import { trackById } from 'v2/modules/shared/util/track-by.util';
import { UiModule } from 'v2/modules/ui/ui.module';

// UTILS

@Component({
  selector: 'lum-order-shipments-details',
  templateUrl: './order-shipments-details.component.html',
  styleUrls: ['./order-shipments-details.component.scss'],
  standalone: true,
  imports: [CommonModule, MaterialCustomModule, UiModule, PipeModule],
})
export class OrderShipmentsDetailsComponent implements OnInit {
  shipment$ = new BehaviorSubject<IShipment | null>(null);
  loading$ = new BehaviorSubject<boolean>(true);

  trackById = trackById;

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA)
    public data :{
      id :number;
    },
    private dialogRef :MatLegacyDialogRef<OrderShipmentsDetailsComponent>,
    private shipstationShipmentApiService :ShipstationShipmentApiService,
    private snackBar :MatLegacySnackBar,
  ) {}

  ngOnInit() :void {
    this.loadShipment();
  }

  onClose() :void {
    this.dialogRef.close();
  }

  private loadShipment() :void {
    this.loading$.next(true);
    this.shipstationShipmentApiService
      .getShipmentById(this.data.id, {
        relations: [
          'shipmentItems',
          'shipstationSalesOrder.warehouseGroup',
          'fulfillmentOrder.warehouseGroup',
        ].join('|'),
      })
      .subscribe({
        next: (shipment) => {
          this.shipment$.next(shipment);
          this.loading$.next(false);
        },
        error: (error) => {
          this.loading$.next(false);
          this.snackBar.open('Failed to load shipment details', 'Close', {
            duration: SnackBarConfig.SUCCESS.duration,
          });
          this.dialogRef.close();
        },
      });
  }
}
